import React, { useEffect, useRef } from 'react';
import { Button, Modal, Box, Typography } from '@mui/material';

const modalStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
    maxWidth: '90%',
    width: '500px',
    zIndex: 9999
};

const WelcomePopup = ({ open, onClose }) => {
    const boxRef = useRef();

    useEffect(() => {
        function handleOutsideClick(event) {
            if (boxRef.current && !boxRef.current.contains(event.target)) {
                onClose();
            }
        }

        if (open) {
            document.addEventListener('mousedown', handleOutsideClick);
        }

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [open, onClose]);

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle} ref={boxRef}>
                <Typography variant="h6" gutterBottom>
                    Καλωσήρθατε στο HeriScope!
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Μια ανοιχτή, συμμετοχική πλατφόρμα για τα κτίρια πολιτιστικής κληρονομιάς σε αχρησία του Μεταξουργείου.
                </Typography>
                <ul>
                    <li>Δείτε τον χάρτη και εξερευνήστε τα κτίρια που έχουν ήδη καταγραφεί.</li>
                    <li>Προσθέστε πληροφορίες για ένα κτίριο που υπάρχει στη βάση.</li>
                    <li>Καταχωρίστε ένα νέο κτίριο που θεωρείτε ότι πρέπει να συμπεριληφθεί.</li>
                </ul>
                <Typography variant="body2" sx={{ mt: 2 }}>
                    Μαζί μπορούμε να φροντίσουμε τα κτίρια της πόλης μας!
                </Typography>
                <Typography variant="body2" sx={{ mt: 1 }}>Ξεκινήστε τώρα!</Typography>
                <Box sx={{ mt: 3, textAlign: 'right' }}>
                    <Button className="close-popup-box" variant="contained" onClick={onClose}>Κλείσιμο</Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default WelcomePopup;
